<div class="bg-layer" [ngClass]="colorClass"></div>
<div
  class="progress-bar"
  [ngClass]="colorClass"
  role="progressbar"
  [style.width]="progress"
  [attr.aria-valuenow]="value"
  aria-valuemin="0"
  [attr.aria-valuemax]="max"
></div>
